/**
 * @constructor
 * @implements {Foundation.View.Interface.Spinner}
 */
Foundation.View.Mobile.Spinner = function (selector) {
    Foundation.documentReady.then(function () {
        this.contentView = jQuery(selector);
        if (!this.contentView[0]) this.contentView = jQuery(document.body);

        // On mobile, doing a spinner over a particular element is a little much.
        // So let's just display the jQuery Mobile loading thingy. But only if
        // our related content view is visible.
        if (this.contentView.is(":visible")) this.show();
    }.bind(this));
};

Foundation.View.Mobile.Spinner.prototype.show = function () {
    //console.log('Foundation.View.Mobile.Spinner:show');
    //if (this.contentView.is(":visible")) jQuery.mobile.showPageLoadingMsg();

};

Foundation.View.Mobile.Spinner.prototype.hide = function () {
    //console.log('Foundation.View.Mobile.Spinner:hide');
    //jQuery.mobile.hidePageLoadingMsg();
};

Foundation.View.Spinner = Foundation.View.Mobile.Spinner;
